module.exports = __webpack_public_path__ + "media/site/images/ecommerce/ecommerce-banner-2@1x-892d70e44f18162813a2cdfa116e02e8.png";